// 2026-07-09 - FormuLearning - Autosave OFF 지연저장 버퍼 (이슈 #33 4단계)
// 파일 위치: frontend/src/stores/saveBufferStore.ts
// Autosave OFF일 때 각 StepCard의 미저장(dirty) 상태와 flush(지연 PUT) 실행기를 전역에서 관리한다.
// - dirtySteps: 배지·네비게이션 가드가 구독하는 상태(zustand)
// - flushers: 리렌더 불필요한 실행기이므로 모듈 레벨 Map으로 보관(구독 대상 아님)

import { create } from 'zustand'

// 스텝별 flush 실행기 — 각 StepCard가 useDeferredSave로 등록. 상태가 아니므로 store 밖에 둔다.
const flushers = new Map<number, () => Promise<void>>()

interface SaveBufferState {
  dirtySteps: Record<number, boolean>
  markDirty: (step: number, dirty: boolean) => void
  registerFlusher: (step: number, fn: () => Promise<void>) => void
  unregister: (step: number) => void
  flushStep: (step: number) => Promise<void>
  hasDirty: () => boolean
  clearDirty: () => void
}

export const useSaveBuffer = create<SaveBufferState>((set, get) => ({
  dirtySteps: {},

  markDirty: (step, dirty) =>
    set((s) => {
      if ((s.dirtySteps[step] ?? false) === dirty) return s // 변화 없으면 리렌더 회피
      return { dirtySteps: { ...s.dirtySteps, [step]: dirty } }
    }),

  registerFlusher: (step, fn) => {
    flushers.set(step, fn)
  },

  unregister: (step) => {
    flushers.delete(step)
    set((s) => {
      if (!(step in s.dirtySteps)) return s
      const next = { ...s.dirtySteps }
      delete next[step]
      return { dirtySteps: next }
    })
  },

  // 해당 스텝의 지연 PUT을 실행(등록된 flush 호출). ON 모드·미등록·미변경이면 no-op.
  flushStep: async (step) => {
    const fn = flushers.get(step)
    if (fn) await fn()
    get().markDirty(step, false)
  },

  hasDirty: () => Object.values(get().dirtySteps).some(Boolean),

  // 프로젝트 전환 시 미저장 상태·누적 버퍼를 폐기. flusher는 카드 언마운트가 정리한다.
  clearDirty: () => set({ dirtySteps: {} }),
}))
